import { CoreType } from '../shared/Contracts'

export type Project = {
  id: string
  externalId: string | null
  complexId: string | null
  constructionId: string | null
  name: string
  description: string | null
  type: ProjectType
  status: ProjectStatus
  projectManager: string | null
  startDate: string | null
  endDate: string | null
  created: string
  lastModified: string
  budget: number | null
  btaRebuild: number | null
  btaNewConstruction: number | null
  btaExtension: number | null
  moveDate: string | null
}

export const PROJECT_TYPES = [
  'ADMINISTRATIVE',
  'TENANT_ADAPTATION',
  'MISCELLANEOUS',
  'ENERGY',
  'DEVELOPMENT',
  'BUSINESS_INVESTIGATION',
  'INVESTMENT',
  'NEW_CONSTRUCTION',
  'MAINTENANCE',
  'STRATEGIC_INVESTIGATION',
  'UNKNOWN'
] as const
export type ProjectType = (typeof PROJECT_TYPES)[number]

export const EXTERNAL_PROJECT_TYPES = [
  'TENANT_ADAPTATION',
  'MISCELLANEOUS',
  'ENERGY',
  'DEVELOPMENT',
  'INVESTMENT',
  'MAINTENANCE',
  'UNKNOWN'
] as const

export const PROJECT_STATUSES = [
  'IN_PROGRESS',
  'PLANNED',
  'NOT_STARTED',
  'ON_HOLD',
  'UNKNOWN',
  'COMPLETED'
] as const

export const EXTERNAL_PROJECT_STATUSES = ['PLANNED', 'IN_PROGRESS', 'ON_HOLD', 'UNKNOWN'] as const

export type ProjectStatus = (typeof PROJECT_STATUSES)[number]

export type InformationQuery = {
  complexIds?: string[]
  constructionIds?: string[]
  types?: ProjectType[]
  statuses?: ProjectStatus[]
  budget?: { from?: number; to?: number }
  internal: boolean
}

export type InformationResponse = {
  complexIds: string[]
  constructionIds: string[]
  projectTypes: string[]
}

export type FilterQuery = {
  entityType?: CoreType
  entityIds?: string[]
  types?: ProjectType[]
  statuses?: ProjectStatus[]
  budget?: { from?: number; to?: number }
}

export type MeasurementSplit = {
  key: string | null
  value: number | null
}

export type Measurement = {
  type?: ProjectType
  status?: ProjectStatus
  splitBy?: CoreType
  splits?: MeasurementSplit[]
}

export type MeasurementQuery = {
  filter: FilterQuery
  internal: boolean
  measurements: Measurement[]
}

export type MeasurementResponse = {
  filter: FilterQuery
  measurements: Measurement[]
}
